export default "https://cdn.questicon.mathletics.com/assets/images/m_coin_outlined-695082cbc8327322dfc89ea66168d045.svg";